module.exports = __webpack_public_path__ + "media/images/teams/JUVENTUS-3ac6501b3a780607869d5875410d38d6.png";